export const termsContent = {
  title: 'Termos de Uso e Condições de Serviço',
  meta: 'Última atualização: 06/05/2026 | Versão 2.0',
  sections: [
    {
      title: '1. DEFINIÇÕES',
      blocks: [
        { type: 'p', text: 'Para fins destes Termos, aplicam-se as seguintes definições:' },
        {
          type: 'list',
          items: [
            ['Léo Delivery:', ' Plataforma tecnológica de propriedade da empresa detentora da marca, prestadora dos serviços de SaaS.'],
            ['Lojista (ou Usuário):', ' Pessoa física ou jurídica que contrata a plataforma para gerenciar seu estabelecimento.'],
            ['Consumidor Final:', ' Cliente do Lojista que utiliza o cardápio digital para realizar pedidos.'],
            ['SaaS (Software as a Service):', ' Modelo de disponibilização de software via internet como serviço.'],
            ['Painel Administrativo:', ' Interface restrita ao Lojista para gestão de produtos, pedidos e configurações.'],
            ['API:', ' Interface de programação de aplicações que permite a integração entre sistemas, como WhatsApp.']
          ]
        }
      ]
    },
    {
      title: '2. OBJETO E LICENÇA',
      blocks: [
        { type: 'p', text: 'O objeto destes Termos é o licenciamento de uso da plataforma Léo Delivery, em caráter não exclusivo, intransferível e oneroso. A licença não compreende a entrega do código-fonte, estrutura de banco de dados ou qualquer propriedade intelectual além do direito de uso das funcionalidades contratadas.' },
        { type: 'p', text: 'A plataforma reserva-se o direito de implementar atualizações, novas funcionalidades ou remover recursos obsoletos, visando a melhoria contínua, sem necessidade de aviso prévio, desde que mantido o escopo principal do serviço.' }
      ]
    },
    {
      title: '3. CONDIÇÕES DE CADASTRO E SEGURANÇA',
      blocks: [
        { type: 'p', text: 'O Lojista obriga-se a fornecer dados verídicos e manter seu perfil atualizado. O acesso é pessoal e intransferível.' },
        {
          type: 'list',
          items: [
            ['Segurança:', ' O Lojista é o único responsável por manter a confidencialidade de suas credenciais.'],
            ['Uso Indevido:', ' Qualquer suspeita de acesso não autorizado deve ser comunicada em até 24 horas ao suporte.'],
            ['Verificação:', ' O Léo Delivery poderá utilizar meios legais para verificar a identidade do Lojista e a regularidade do CNPJ informado.']
          ]
        }
      ]
    },
    {
      title: '4. OBRIGAÇÕES E CONDUTA DO LOJISTA',
      blocks: [
        { type: 'p', text: 'O Lojista compromete-se a:' },
        {
          type: 'plainList',
          items: [
            'Não utilizar a plataforma para fins ilícitos ou que infrinjam direitos de terceiros;',
            'Não realizar engenharia reversa, descompilação ou cópia da interface;',
            'Não enviar mensagens em massa (SPAM) utilizando as integrações da plataforma;',
            'Manter a regularidade fiscal e sanitária de seu estabelecimento;',
            'Responder civil e criminalmente por qualquer dano causado a consumidores finais através do uso da ferramenta.'
          ]
        },
        { type: 'p', text: 'A violação de qualquer regra de conduta poderá ensejar a suspensão imediata ou rescisão do contrato, sem direito a reembolso.' }
      ]
    },
    {
      title: '5. NÍVEL DE SERVIÇO (SLA) E SUPORTE',
      blocks: [
        { type: 'h3', text: '5.1 Disponibilidade (Uptime)' },
        { type: 'p', text: 'O Léo Delivery envida esforços para manter uma disponibilidade mínima de 99,5% no mês civil.' },
        { type: 'h3', text: '5.2 Exclusões do SLA' },
        { type: 'p', text: 'Não serão considerados períodos de indisponibilidade:' },
        {
          type: 'plainList',
          items: [
            'Manutenções programadas comunicadas com 24h de antecedência;',
            'Falhas nos serviços de terceiros, como WhatsApp Business API, provedores de internet ou cloud hosting;',
            'Ações de hackers ou eventos de força maior;',
            'Problemas nos dispositivos de acesso do Lojista ou do Consumidor.'
          ]
        },
        { type: 'h3', text: '5.3 Suporte Técnico' },
        { type: 'p', text: 'O suporte será prestado em dias úteis, das 09h às 18h, via chat ou e-mail, com tempo de resposta inicial de até 8 horas úteis.' }
      ]
    },
    {
      title: '6. PLANOS, PAGAMENTO E REAJUSTE',
      blocks: [
        { type: 'p', text: 'Os valores são definidos conforme o plano escolhido no ato da contratação.' },
        {
          type: 'list',
          items: [
            ['Faturamento:', ' O pagamento é antecipado (pré-pago).'],
            ['Inadimplência:', ' O atraso superior a 5 dias acarretará a suspensão do acesso. Após 30 dias de atraso, o contrato poderá ser rescindido com exclusão definitiva dos dados.'],
            ['Reajuste Anual:', ' Os valores dos planos serão reajustados anualmente com base na variação positiva do IPCA/IBGE ou, na sua falta, pelo IGPM/FGV.'],
            ['Upgrade/Downgrade:', ' Mudanças de plano podem ser feitas a qualquer tempo, com ajuste proporcional no ciclo seguinte.']
          ]
        }
      ]
    },
    {
      title: '7. LIMITAÇÃO DE RESPONSABILIDADE E INDENIZAÇÃO',
      blocks: [
        { type: 'p', text: 'A responsabilidade total do Léo Delivery por qualquer falha ou prejuízo direto comprovado fica limitada ao valor equivalente a 3 mensalidades do plano vigente do Lojista.' },
        { type: 'p', text: 'Não haverá responsabilidade por lucros cessantes, perda de receita, perda de oportunidade de negócio, danos morais ou indiretos, nem por prejuízos decorrentes de entregas não realizadas ou alimentos em más condições, que são de responsabilidade exclusiva do Lojista.' }
      ]
    },
    {
      title: '8. PROPRIEDADE INTELECTUAL E AUDITORIA',
      blocks: [
        { type: 'p', text: 'Todos os direitos sobre a marca Léo Delivery, domínio, código-fonte e design são reservados. O Lojista concede ao Léo Delivery o direito de utilizar sua marca/logotipo em materiais de portfólio e marketing enquanto durar o contrato.' },
        { type: 'p', text: 'O Léo Delivery reserva-se o direito de realizar auditorias sistêmicas para verificar se o uso da plataforma está de acordo com os limites contratados.' }
      ]
    },
    {
      title: '9. PRIVACIDADE E PROTEÇÃO DE DADOS (LGPD)',
      blocks: [
        { type: 'p', text: 'As partes declaram conformidade com a Lei 13.709/2018. O Lojista figura como Controlador e o Léo Delivery como Operador.' },
        {
          type: 'plainList',
          items: [
            'O Lojista deve possuir base legal válida para coletar dados de seus clientes.',
            'O Léo Delivery tratará os dados apenas para a finalidade de execução do serviço.',
            'Em caso de incidente de segurança, o Léo Delivery comunicará o Lojista em prazo razoável.'
          ]
        }
      ]
    },
    {
      title: '10. RESCISÃO E PORTABILIDADE',
      blocks: [
        { type: 'p', text: 'O contrato poderá ser rescindido por qualquer das partes mediante aviso prévio de 30 dias, sem ônus, salvo em planos anuais com fidelidade.' },
        { type: 'p', text: 'Após a rescisão, o Lojista terá 15 dias para solicitar a exportação de seus dados em formato CSV ou JSON. Após este prazo, os dados poderão ser permanentemente eliminados.' }
      ]
    },
    {
      title: '11. DISPOSIÇÕES GERAIS E FORO',
      blocks: [
        { type: 'p', text: 'A tolerância quanto ao descumprimento de qualquer cláusula não constitui renúncia ao direito de exigi-la posteriormente. Estes termos são regidos pelas leis da República Federativa do Brasil.' },
        { type: 'p', text: 'Caso qualquer disposição destes Termos seja considerada inválida por tribunal competente, as demais permanecerão em pleno vigor.' },
        { type: 'p', text: 'Fica eleito o Foro da Comarca de São Paulo/SP para dirimir quaisquer controvérsias oriundas deste instrumento, com exclusão de qualquer outro por mais privilegiado que seja.' }
      ]
    },
    {
      title: '12. CONTATO',
      blocks: [
        { type: 'p', text: 'Dúvidas sobre estes termos podem ser enviadas para o suporte através do painel administrativo ou pelo e-mail: suporte@leodelivery.com.br.' }
      ]
    }
  ]
};

export const privacyContent = {
  title: 'Política de Privacidade',
  meta: 'Última atualização: 06/05/2026',
  sections: [
    {
      blocks: [
        { type: 'p', text: 'A sua privacidade é fundamental para a Léo Delivery. Esta Política de Privacidade descreve como coletamos, utilizamos, compartilhamos e protegemos seus dados pessoais em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018).' }
      ]
    },
    {
      title: '1. PAPÉIS NA PROTEÇÃO DE DADOS',
      blocks: [
        { type: 'p', text: 'Para que você entenda como seus dados são tratados, é importante definir as responsabilidades:' },
        {
          type: 'list',
          items: [
            ['Controlador:', ' O Lojista que utiliza nossa plataforma é o controlador dos dados de seus clientes finais.'],
            ['Operador:', ' O Léo Delivery atua como operador, processando os dados conforme as instruções do Lojista e para garantir o funcionamento do serviço.']
          ]
        }
      ]
    },
    {
      title: '2. DADOS COLETADOS',
      blocks: [
        { type: 'h3', text: '2.1 Dados fornecidos pelo Lojista' },
        { type: 'p', text: 'Nome da empresa, CNPJ, endereço, telefone de contato e dados de pagamento para assinatura do serviço.' },
        { type: 'h3', text: '2.2 Dados dos Clientes Finais (Consumidores)' },
        {
          type: 'plainList',
          items: [
            'Nome completo e telefone (WhatsApp);',
            'Endereço de entrega completo e referências;',
            'Histórico de pedidos e preferências de consumo;',
            'Localização, se autorizada pelo navegador, para cálculo de frete.'
          ]
        },
        { type: 'h3', text: '2.3 Dados de Navegação (Cookies)' },
        { type: 'p', text: 'Coletamos informações como endereço IP, tipo de dispositivo, navegador e comportamento de navegação para fins de segurança e melhoria da interface.' }
      ]
    },
    {
      title: '3. FINALIDADE DO USO DAS INFORMAÇÕES',
      blocks: [
        { type: 'p', text: 'Utilizamos os dados coletados exclusivamente para viabilizar pedidos, calcular taxas de entrega, enviar notificações, gerar relatórios de vendas e prevenir fraudes.' }
      ]
    },
    {
      title: '4. COMPARTILHAMENTO DE DADOS',
      blocks: [
        { type: 'p', text: 'O Léo Delivery não vende nem aluga dados pessoais a terceiros. O compartilhamento ocorre apenas quando estritamente necessário para gateways de pagamento, provedores de infraestrutura ou cumprimento de ordens legais.' }
      ]
    },
    {
      title: '5. SEGURANÇA E ARMAZENAMENTO',
      blocks: [
        { type: 'p', text: 'Adotamos práticas de segurança de mercado, como criptografia SSL, firewalls e backups regulares. Os dados são armazenados em servidores seguros enquanto durar a relação contratual ou conforme exigido por prazos legais.' }
      ]
    },
    {
      title: '6. SEUS DIREITOS',
      blocks: [
        {
          type: 'plainList',
          items: [
            'Confirmar a existência de tratamento de dados;',
            'Acessar, corrigir ou anonimizar dados incompletos ou inexatos;',
            'Solicitar a exclusão de dados desnecessários;',
            'Revogar o consentimento a qualquer momento.'
          ]
        }
      ]
    },
    {
      title: '7. USO DE COOKIES',
      blocks: [
        { type: 'p', text: 'Utilizamos cookies para lembrar preferências e facilitar o preenchimento de dados em pedidos futuros. Você pode gerenciar ou desativar cookies nas configurações do navegador.' }
      ]
    },
    {
      title: '8. ALTERAÇÕES NESTA POLÍTICA',
      blocks: [
        { type: 'p', text: 'Esta política pode ser atualizada a qualquer momento. Recomendamos a visita periódica a esta página. Alterações significativas serão notificadas através de avisos em nosso site.' }
      ]
    },
    {
      title: '9. CONTATO E DPO',
      blocks: [
        { type: 'p', text: 'Para exercer seus direitos ou tirar dúvidas, entre em contato com nosso Encarregado de Proteção de Dados pelo e-mail: privacidade@leodelivery.com.br.' }
      ]
    }
  ]
};

export const legalDocuments = {
  terms: termsContent,
  privacy: privacyContent
};
